import React from 'react';
import { Star } from 'lucide-react';
const TESTIMONIALS = [{
  text: 'Pensé que el problema era yo. Este material me devolvió la calma.',
  author: 'Lucía, mamá primeriza – 32 años'
}, {
  text: 'Mi bebé sigue despertándose, pero ahora sé qué hacer y dormimos mejor.',
  author: 'Marcos, papá – 35 años'
}, {
  text: 'Por primera vez no sentí culpa al acompañar el sueño.',
  author: 'Carla, mamá – 29 años'
}, {
  text: 'Simple, claro y respetuoso. Exactamente lo que necesitaba.',
  author: 'Sofía, mamá – 38 años'
}, {
  text: 'Me ayudó a confiar en mi intuición y en mi bebé.',
  author: 'Juan, papá – 41 años'
}];
export function Testimonials() {
  return <section className="py-16 px-4 bg-gray-50" data-id="element-166">
      <div className="max-w-6xl mx-auto" data-id="element-167">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-12" data-id="element-168">
          💬 Lo que dicen otras mamás y papás
        </h2>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-169">
          {TESTIMONIALS.map((t, i) => <div key={i} className="bg-white p-6 rounded-xl shadow-sm border border-gray-100 hover:shadow-md transition-shadow" data-id="element-170">
              <div className="flex gap-1 text-yellow-400 mb-4" data-id="element-171">
                {[1, 2, 3, 4, 5].map(s => <Star key={s} className="w-5 h-5 fill-current" data-id="element-172" />)}
              </div>
              <p className="text-gray-700 italic mb-6 text-lg" data-id="element-173">"{t.text}"</p>
              <div className="flex items-center gap-3" data-id="element-174">
                <div className="w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center font-bold text-blue-600" data-id="element-175">
                  {t.author[0]}
                </div>
                <span className="font-bold text-gray-900 text-sm" data-id="element-176">
                  {t.author}
                </span>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}